import { STEP_TYPES } from './constants';
import { StepProps } from '../types';

export function getDefaultStep({ steps }: { steps: string[] }): string {
	return steps[0];
}

export function getEffectiveSteps({
	steps = {},
	flow
}: {
	steps: Record<string, StepProps>;
	flow: string[];
}): string[] {
	const effectiveSteps: string[] = [];

	flow.forEach((key: string) => {
		const step: StepProps = steps[key];

		if (step && step.type !== STEP_TYPES.subStep) {
			effectiveSteps.push(key);
		}
	});

	return effectiveSteps;
}

export function isOfTypeSubStep(stepDetails: StepProps, as: (typeof STEP_TYPES)[keyof typeof STEP_TYPES]): boolean {
	return (
		as === STEP_TYPES.subStep && (stepDetails.type === STEP_TYPES.subStep || stepDetails.type === STEP_TYPES.hybrid)
	);
}

export const lastElement = (arr = []) => arr?.slice(-1)?.[0];
